export default __webpack_public_path__ + "static/media/childhood.16d50efb.svg";